import { convertToDateTime } from '../helper/dateTime-helper';

/**
 * Model to USA Wrestling membership details
 */
export class UsaWrestlingMembership {
    public isValid: boolean;
    public invalidReason: string;
    public usawId: number;
    public firstName: string;
    public lastName: string;
    public dateOfBirth: Date;
    public stateAbbreviation: string;
    public cardNumber: string;
    public zipCode: string;

    /**
     * Deserialize to json api format
     */
    public deserialize(json: Object): UsaWrestlingMembership {
        this.isValid = json['isValid'];
        this.invalidReason = json['invalidReason'];

        const membership: Object = json['membership'];
        if (membership) {
            this.usawId = membership['usawId'] && parseInt(membership['usawId'], null);
            this.firstName = membership['firstName'];
            this.lastName = membership['lastName'];

            if (membership['dateOfBirth']) {
                this.dateOfBirth = convertToDateTime(membership['dateOfBirth']);
            }

            this.stateAbbreviation = membership['stateAbbreviation'];
            this.cardNumber = membership['cardNumber'];
            this.zipCode = membership['zipCode'];
        }

        return this;
    }
}
